import { translate as t } from "./locale";

interface ImportedScratchProject {
    project: unknown;
    title: string;
}

export const TRAINER_SHARE_IMPORT_MESSAGE =
    t("Import linku dla trenera nie jest obsługiwany. Użyj linku z https://scratch.mit.edu");

const PRODUCTION_ORIGINS = new Set([
    "https://scratch.gp.edu.pl",
    "https://scratch.codinggiants.com",
    "https://scratch.codinggiants.es",
    "https://scratch.codinggiants.mx",
]);
const SHORT_SHARE_PATH = /^\/l\/[A-Za-z0-9_-]{22}$/u;
const LEGACY_SHARE_PATH = /^\/s\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;
const LEGACY_SECRET = /^[A-Za-z0-9_-]{43}$/u;

export const isTrainerShareUrl = (value: string, currentOrigin: string): boolean => {
    try {
        const url = new URL(value.trim());
        if (url.username || url.password) return false;
        if (PRODUCTION_ORIGINS.has(url.origin)) return true;
        if (url.origin !== currentOrigin) return false;
        if (SHORT_SHARE_PATH.test(url.pathname))
            return !url.search && !url.hash;
        if (!LEGACY_SHARE_PATH.test(url.pathname) || url.search) return false;
        const fragment = new URLSearchParams(url.hash.slice(1));
        return fragment.size === 3 && fragment.get("v") === "1" &&
            LEGACY_SECRET.test(fragment.get("k") ?? "") &&
            LEGACY_SECRET.test(fragment.get("c") ?? "");
    } catch {
        return false;
    }
};

export const parseScratchProjectUrl = (value: string): string => {
    const match = /^https:\/\/scratch\.mit\.edu\/projects\/([1-9][0-9]*)\/?$/u.exec(
        value.trim(),
    );
    if (!match) throw new Error("INVALID_SCRATCH_PROJECT_URL");
    return match[1];
};

export const loadScratchProject = async (
    value: string,
    fetchImpl: typeof fetch = fetch,
    currentOrigin = typeof window === "undefined" ? "" : window.location.origin,
): Promise<ImportedScratchProject> => {
    if (isTrainerShareUrl(value, currentOrigin))
        throw new Error(TRAINER_SHARE_IMPORT_MESSAGE);
    const projectId = parseScratchProjectUrl(value);
    const response = await fetchImpl(`/api/imports/scratch/${projectId}`);
    if (response.status === 404)
        throw new Error(t("Nie znaleziono publicznego projektu Scratch"));
    if (response.status === 413)
        throw new Error(t("Projekt Scratch jest zbyt duży"));
    if (!response.ok)
        throw new Error(t("Nie udało się pobrać projektu Scratch"));
    const body = (await response.json()) as ImportedScratchProject;
    if (!body.title || !body.project)
        throw new Error(t("Projekt Scratch ma nieprawidłowy format"));
    return body;
};
